<template>
  <span role="button" :class="[baseCss]" :style="style">
    <btn :icon="icon" :flat="flat" :provider="iconProvider" :color="color" :elevation="elevation" :color-lightness="colorLightness" :bg-color="bgColor" :bg-color-lightness="bgColorLightness" :disabled="disabled" :loading="loading" :type="type" :size="size" :tag="tag" :to="to" @click="$emit('click')" />
  </span>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Fab',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('fab', ['fixed'])
    }
  },
  props: {
    zIndex: {
      type: Number,
      default: 1000
    },
    type: {
      type: String,
      default: 'button',
      validator: value => {
        return ['button', 'submit', 'reset'].includes(value)
      }
    },
    size: {
      type: String,
      default: 'sm',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    },
    top: {
      type: String
    },
    right: {
      type: String,
      default: '3rem'
    },
    bottom: {
      type: String,
      default: '3rem'
    },
    left: {
      type: String
    },
    tag: {
      type: String,
      default: 'button'
    },
    to: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    flat: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    bgColor: {
      type: String,
      default: 'gray'
    },
    color: {
      type: String,
      default: 'black'
    },
    icon: {
      type: String,
      default: 'chevron-up'
    }
  },
  computed: {
    style () {
      return {
        top: this.top,
        left: this.left,
        bottom: this.bottom,
        right: this.right,
        zIndex: this.zIndex
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/fab/fab.vue